import React from "react"
import styled from "@emotion/styled"
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress"

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 15px;
`

const Loader = ({size}) => {
    return (
        <Container>
            <CircularProgress size={size || 32}/>
        </Container>
    );
};

export default Loader;
